import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';
import { PaletteConfig } from 'services/configuration';

export const useStyles = (props: { flow: string | undefined; palette: PaletteConfig | undefined }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      timerOverlayContainer: {
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
        borderRadius: '8px',
        position: 'relative',
        alignItems: 'center',
        width: '60%',
        height: '749px',
        padding: '56px 0px 0px 0px',
        backgroundColor: props.flow === 'fair' ? props.palette?.accent : 'white',
        [theme.breakpoints.down('lg')]: {
          width: '90%',
          height: '800px'
        },
        [theme.breakpoints.only('lg')]: {
          width: '1010px',
          height: '776px'
        }
      },
      timerResetButton: {
        width: '475px',
        [theme.breakpoints.down('lg')]: {
          width: '370px'
        },
        [theme.breakpoints.only('lg')]: {
          width: '418px'
        }
      },
      timerStayButton: {
        width: '475px',
        [theme.breakpoints.down('lg')]: {
          width: '370px'
        },
        [theme.breakpoints.only('lg')]: {
          width: '418px'
        }
      },
      timerOverlayHeaderBox: {
        flex: 'none',
        background: 'transparent',
        textAlign: 'center',
        '& > *': {
          [theme.breakpoints.down('lg')]: {
            maxHeight: '275px'
          }
        }
      }
    })
  );
